import React, { createContext, useContext, useMemo, useState } from "react";

const MenuAppContext = createContext(null);

export const MenuAppProvider = ({ children }) => {
    const [currentMenu, setCurrentMenu] = useState("NEW");

    const value = useMemo(
        () => ({ currentMenu, setCurrentMenu }),
        [currentMenu]
    );

    return (
        <MenuAppContext.Provider value={value}>
            {children}
        </MenuAppContext.Provider>
    );
};

export const useCurrentMenu = () => {
    const context = useContext(MenuAppContext);

    if (!context) {
        throw new Error("useCurrentMenu must be used within an MenuAppProvider");
    }

    return context;
};
